import React from "react";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import "./App.css";

import { baseUrl } from "./api/API";
import { userRole } from "./constant/userConfig";
import Home from "./pages/home";
import Login from "./pages/Login";
import ProtectedLayout from "./ProtectedLayout";
import AssuranceRoutes from "./route/assuranceRoutes";
import CliniqueRoutes from "./route/CliniqueRoutes";
import LaboRoutes from "./route/LaboRoutes";
import PharmacieRoutes from "./route/PharmacieRoutes";
import useAuthStore from "./store/authStore";

const MainLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

function App() {
  const user = useAuthStore((state) => state.user);
  // const entity = useEntityStore((state) => state.entity);
  const apiUrl = baseUrl;

  const router = createBrowserRouter([
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "assurance/*",
          element: (
            <ProtectedLayout
              allowedRoles={[
                userRole.admin_assurance,
                userRole.agent_assurance,
                userRole.medecin_assurance,
              ]}
            />
          ),
          children: AssuranceRoutes,
        },
        {
          path: "pharmacie/*",
          element: (
            <ProtectedLayout
              allowedRoles={[
                userRole.agent_pharmacie,
                userRole.admin_pharmacie,
              ]}
            />
          ),
          children: PharmacieRoutes,
        },
        {
          path: "labo/*",
          element: (
            <ProtectedLayout
              allowedRoles={[
                userRole.agent_laboratoire,
                userRole.admin_laboratoire,
              ]}
            />
          ),
          children: LaboRoutes,
        },
        {
          path: "clinique/*",
          element: (
            <ProtectedLayout
              allowedRoles={[
                userRole.agent_clinique,
                userRole.admin_clinique,
                userRole.medecin_clinique,
              ]}
            />
          ),
          children: CliniqueRoutes,
        },
        {
          path: "*",
          element: (
            <div>
              <h1>404 - Not Found</h1>
            </div>
          ),
        },
      ],
    },
  ]);
  //console.log("baseUrl", baseUrl);

  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <div className="App container-fluid p-0  vh-100 vw-100">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

export default App;
